import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import changelog from '../../CHANGELOG.md?raw'
import styles from './ChangeLog.module.css'

export interface ChangeLogProps extends HTMLAttributes<HTMLDivElement> {}

export default function ChangeLog({ className, ...props }: ChangeLogProps) {
	return (
		<div className={clsx(styles.root, styles.markdown, className)} {...props}>
			<Markdown remarkPlugins={[remarkGfm]}>{changelog}</Markdown>
		</div>
	)
}
